import { type FC } from 'react';

import { range } from 'lodash';

import { useCustomStyles } from './AccoStars.style';
import { Icon, type IconProps } from '../Icon';

export interface AccoStarsProps {
	/** Number of stars to give to the property e.g. rating */
	starsCount: number;
	/** Classname to pass through to the component */
	className?: string;
	/** Size of the star icon */
	size?: IconProps['size'];
}

export const AccoStars: FC<AccoStarsProps> = ({ starsCount, className, size = 'xSmall' }) => {
	const { classes, cx } = useCustomStyles();

	return (
		<span className={cx(classes.wrapper, className)}>
			{range(starsCount).map((_, number) => (
				<Icon key={number} type="star" className={classes.starIcon} size={size} />
			))}
		</span>
	);
};
